"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { useClickAway, useDebounce, useKeyPressEvent } from "react-use";
import { commonApiFetch } from "@/services/api/common-api";
import RepCategorySearchDropdown from "./RepCategorySearchDropdown";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
export enum RepCategorySearchSize {
  SM = "SM",
  MD = "MD",
}
const MIN_SEARCH_LENGTH = 3;
export default function RepCategorySearch(t0) {
  const $ = _c(63);
  const {
    category,
    size: t1,
    disableInputCategoryAsValue: t2,
    error: t3,
    setCategory
  } = t0;
  const size = t1 === undefined ? RepCategorySearchSize.MD : t1;
  const disableInputCategoryAsValue = t2 === undefined ? false : t2;
  const error = t3 === undefined ? false : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = getRandomObjectId();
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const randomId = t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      [RepCategorySearchSize.SM]: "tw-py-3 tw-text-sm",
      [RepCategorySearchSize.MD]: "tw-pb-3 tw-pt-3 tw-text-md"
    };
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const INPUT_CLASSES = t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      [RepCategorySearchSize.SM]: "tw-text-sm",
      [RepCategorySearchSize.MD]: "tw-text-md"
    };
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const LABEL_CLASSES = t6;
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      [RepCategorySearchSize.SM]: "tw-top-3",
      [RepCategorySearchSize.MD]: "tw-top-3.5"
    };
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const ICON_CLASSES = t7;
  const [searchCriteria, setSearchCriteria] = useState(category);
  let t8;
  let t9;
  if ($[4] !== category) {
    t8 = () => {
      setSearchCriteria(category);
    };
    t9 = [category];
    $[4] = category;
    $[5] = t8;
    $[6] = t9;
  } else {
    t8 = $[5];
    t9 = $[6];
  }
  useEffect(t8, t9);
  const [debouncedValue, setDebouncedValue] = useState(searchCriteria);
  let t10;
  if ($[7] !== searchCriteria) {
    t10 = () => setDebouncedValue(searchCriteria);
    $[7] = searchCriteria;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== searchCriteria) {
    t11 = [searchCriteria];
    $[9] = searchCriteria;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  useDebounce(t10, 200, t11);
  let t12;
  let t13;
  if ($[11] !== debouncedValue) {
    t12 = [QueryKey.REP_CATEGORIES_SEARCH, debouncedValue];
    t13 = async () => await commonApiFetch({
      endpoint: "/rep/categories",
      params: {
        param: debouncedValue ?? ""
      }
    });
    $[11] = debouncedValue;
    $[12] = t12;
    $[13] = t13;
  } else {
    t12 = $[12];
    t13 = $[13];
  }
  const t14 = !!debouncedValue && debouncedValue.length >= MIN_SEARCH_LENGTH;
  let t15;
  if ($[14] !== t12 || $[15] !== t13 || $[16] !== t14) {
    t15 = {
      queryKey: t12,
      queryFn: t13,
      enabled: t14
    };
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  const {
    data
  } = useQuery(t15);
  const [isOpen, setIsOpen] = useState(false);
  let t16;
  if ($[18] !== setCategory) {
    t16 = newValue => {
      setCategory(newValue);
      setSearchCriteria(newValue);
      setIsOpen(false);
    };
    $[18] = setCategory;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const onValueChange = t16;
  let t17;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = newV => {
      if (newV) {
        setIsOpen(true);
      }
    };
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  const onFocusChange = t17;
  let t18;
  if ($[21] !== setCategory) {
    t18 = newV_0 => {
      setSearchCriteria(newV_0);
      if (!newV_0) {
        setCategory(null);
      }
    };
    $[21] = setCategory;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  const onSearchCriteriaChange = t18;
  const wrapperRef = useRef(null);
  let t19;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setIsOpen(false);
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  useClickAway(wrapperRef, t19);
  let t20;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = () => setIsOpen(false);
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  useKeyPressEvent("Escape", t20);
  let t21;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = [];
    $[25] = t21;
  } else {
    t21 = $[25];
  }
  const [categories, setCategories] = useState(t21);
  let t22;
  if ($[26] !== data || $[27] !== debouncedValue || $[28] !== disableInputCategoryAsValue) {
    t22 = () => {
      if (!debouncedValue) {
        setCategories([]);
        return;
      }
      if (debouncedValue.length < MIN_SEARCH_LENGTH) {
        setCategories([]);
        return;
      }
      if (disableInputCategoryAsValue) {
        setCategories(data ?? []);
        return;
      }
      if (!data?.length) {
        setCategories([debouncedValue]);
        return;
      }
      setCategories([debouncedValue, ...data.filter(i => i !== debouncedValue)]);
    };
    $[26] = data;
    $[27] = debouncedValue;
    $[28] = disableInputCategoryAsValue;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  let t23;
  if ($[30] !== data || $[31] !== debouncedValue) {
    t23 = [data, debouncedValue];
    $[30] = data;
    $[31] = debouncedValue;
    $[32] = t23;
  } else {
    t23 = $[32];
  }
  useEffect(t22, t23);
  const t24 = searchCriteria ?? "";
  let t25;
  if ($[33] !== onSearchCriteriaChange) {
    t25 = e => onSearchCriteriaChange(e.target.value);
    $[33] = onSearchCriteriaChange;
    $[34] = t25;
  } else {
    t25 = $[34];
  }
  let t26;
  let t27;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = () => onFocusChange(true);
    t27 = () => onFocusChange(false);
    $[35] = t26;
    $[36] = t27;
  } else {
    t26 = $[35];
    t27 = $[36];
  }
  const t28 = `${INPUT_CLASSES[size]} ${error ? "tw-ring-error focus:tw-border-error focus:tw-ring-error tw-caret-error" : "tw-ring-iron-700 focus:tw-border-blue-500 tw-caret-primary-400 focus:tw-ring-primary-400 hover:tw-ring-iron-650"} tw-form-input tw-block tw-w-full tw-text-base tw-rounded-lg tw-border-0 tw-appearance-none ${searchCriteria ? "focus:tw-text-white tw-text-primary-400" : "tw-text-white"} tw-font-medium tw-border-iron-700 tw-peer tw-pl-10 tw-py-3 tw-pr-4 tw-bg-iron-900 focus:tw-bg-iron-900 tw-shadow-sm tw-ring-1 tw-ring-inset placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-transition tw-duration-300 tw-ease-out`;
  let t29;
  if ($[37] !== t24 || $[38] !== t25 || $[39] !== t28) {
    t29 = <input type="text" value={t24} onChange={t25} onFocus={t26} onBlur={t27} id={randomId} className={t28} placeholder=" " />;
    $[37] = t24;
    $[38] = t25;
    $[39] = t28;
    $[40] = t29;
  } else {
    t29 = $[40];
  }
  let t30;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <svg className="tw-text-iron-300 tw-pointer-events-none tw-absolute tw-left-3 tw-top-3.5 tw-h-5 tw-w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clipRule="evenodd" /></svg>;
    $[41] = t30;
  } else {
    t30 = $[41];
  }
  let t31;
  if ($[42] !== category?.length || $[43] !== onValueChange || $[44] !== size) {
    t31 = !!category?.length && <svg onClick={() => onValueChange(null)} aria-label="Clear category" className={`${ICON_CLASSES[size]} tw-cursor-pointer tw-absolute tw-right-3 tw-top-3.5 tw-h-5 tw-w-5 tw-text-iron-400 hover:tw-text-error tw-transition tw-duration-300 tw-ease-out`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 7L7 17M7 7L17 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[42] = category?.length;
    $[43] = onValueChange;
    $[44] = size;
    $[45] = t31;
  } else {
    t31 = $[45];
  }
  const t32 = `${LABEL_CLASSES[size]} ${error ? "peer-focus:tw-text-error" : "peer-focus:tw-text-primary-400"} tw-text-iron-500 tw-rounded-lg tw-absolute tw-cursor-text tw-font-medium tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-z-10 tw-origin-[0] tw-bg-iron-900 peer-focus:tw-bg-iron-900 tw-ml-7 tw-px-2 peer-focus:tw-px-2 peer-placeholder-shown:tw-scale-100 
      peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1`;
  let t33;
  if ($[46] !== t32) {
    t33 = <label htmlFor={randomId} className={t32}>Rep Category</label>;
    $[46] = t32;
    $[47] = t33;
  } else {
    t33 = $[47];
  }
  let t34;
  if ($[48] !== categories || $[49] !== category || $[50] !== isOpen || $[51] !== onValueChange) {
    t34 = <RepCategorySearchDropdown open={isOpen} selected={category} categories={categories} onSelect={onValueChange} />;
    $[48] = categories;
    $[49] = category;
    $[50] = isOpen;
    $[51] = onValueChange;
    $[52] = t34;
  } else {
    t34 = $[52];
  }
  let t35;
  if ($[53] !== t29 || $[54] !== t31 || $[55] !== t33 || $[56] !== t34) {
    t35 = <div className="tw-relative tw-group tw-w-full">{t29}{t30}{t31}{t33}{t34}</div>;
    $[53] = t29;
    $[54] = t31;
    $[55] = t33;
    $[56] = t34;
    $[57] = t35;
  } else {
    t35 = $[57];
  }
  let t36;
  if ($[58] !== error) {
    t36 = error && <div className="tw-pt-1.5 tw-relative tw-flex tw-items-center tw-gap-x-2"><svg className="tw-size-5 tw-flex-shrink-0 tw-text-error" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><div className="tw-text-error tw-text-xs tw-font-medium">Please enter rep cateogry</div></div>;
    $[58] = error;
    $[59] = t36;
  } else {
    t36 = $[59];
  }
  let t37;
  if ($[60] !== t35 || $[61] !== t36) {
    t37 = <div className="tw-relative tw-w-full" ref={wrapperRef}>{t35}{t36}</div>;
    $[60] = t35;
    $[61] = t36;
    $[62] = t37;
  } else {
    t37 = $[62];
  }
  return t37;
}